import { NotesListDetailData } from '@converge/graphql';
import { NoteListDetail } from './note.list.detail';

export interface INoteListProps {
  notes: NotesListDetailData[];
}

export const NoteList = ({ notes }: INoteListProps) => {
  return (
    <>
      {notes.map((note, index) => (
        <NoteListDetail key={index} note={note} />
      ))}
    </>
  );
};
